import { render, staticRenderFns } from "./LicenceExpiryText.vue?vue&type=template&id=42ff21cc&scoped=true&"
import script from "./LicenceExpiryText.vue?vue&type=script&lang=js&"
export * from "./LicenceExpiryText.vue?vue&type=script&lang=js&"
import style0 from "./LicenceExpiryText.vue?vue&type=style&index=0&id=42ff21cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff21cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
